<template>
  <div class="video-card-duration-container" v-if="getDuration()">
    <b>Duration:</b>
    <span class="video-card-duration-time">{{ getDuration() }}</span>
  </div>
</template>

<script>
export default {
  name: 'VideoAssetDuration',

  props: {
    videoAsset: {
      type: Object,
      required: true
    },
  },

  methods: {
    getDuration() {
      const muxAsset = this.videoAsset.mux_asset;

      if (!muxAsset) return false;

      let duration = muxAsset.duration;

      // If main duration is not available, look into tracks.
      if (!duration && muxAsset.tracks) {
        const tracks = JSON.parse(muxAsset.tracks);
        const videoTrack = tracks.find(track => track.type === 'video');
        duration = videoTrack ? videoTrack.duration : null;
      }

      if (!duration) return false;

      const date = new Date(null);
      date.setSeconds(duration);
      return date.toISOString().substr(11, 8);
    },
  }
}

</script>

<style scoped>
  .video-card-duration-container {
    font-size: 12px;
  }
</style>
